let core;
export function setEphemonCore(value) {
    core = value;
}
export function getEphemonCore() {
    return core;
}
export function hasEphemonCore() {
    return core !== undefined && core !== null;
}
export function requireEphemonCore() {
    if (core === undefined || core === null) {
        throw new Error('[ephemon] The core has not been initialized yet.');
    }
    return core;
}
